<template lang="pug">
	router-link(:to="{name: 'project.takeoff', params: {id: params.data.projId} }") {{ params.data.name }}
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
	name: 'ag-grid-project-name'
})
</script>



// WEBPACK FOOTER //
// src/app/project/ag-grid/progress-in-project-name.vue